import { SERVER_URL } from "../../../constants.js";

function getToken() {
  return sessionStorage.getItem("bearer");
}

export function joinUrl(base, path) {
  const b = String(base || "").replace(/\/+$/, "");
  const p = String(path || "").replace(/^\/+/, "");
  return `${b}/${p}`;
}

async function safeJson(res) {
  const text = await res.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

export class HttpError extends Error {
  constructor(message, { status, url, method, body, headers }) {
    super(message);
    this.name = "HttpError";
    this.status = status;
    this.url = url;
    this.method = method;
    this.body = body;
    this.headers = headers;
  }
}

export async function apiRequest(path, opts = {}) {
  const token = getToken();
  const url = joinUrl(SERVER_URL, path);

  const { headers = {}, body, signal, method = "GET", ...rest } = opts;

  const res = await fetch(url, {
    method,
    signal,
    ...rest,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(body ? { "Content-Type": "application/json" } : {}),
      ...headers,
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const responseBody = res.status === 204 ? null : await safeJson(res);

  if (!res.ok) {
    const msg =
      `${method.toUpperCase()} ${path} failed (${res.status})` +
      (responseBody
        ? ` ${typeof responseBody === "string" ? responseBody : JSON.stringify(responseBody)}`
        : "");

    throw new HttpError(msg, {
      status: res.status,
      url,
      method: method.toUpperCase(),
      body: responseBody,
      headers: res.headers,
    });
  }

  return responseBody;
}